// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f46840db","122":"e5b76c60","188":"1f02c9ac","226":"98f32597","305":"6fcf5593","375":"5c605fde","487":"f1f636bd","490":"b3cb1fcd","667":"017c0721","851":"248596c3","857":"9c02bd80","886":"13932cbe"}[chunkId] + ".chunk.js";
};